export default __webpack_public_path__ + "static/media/warloc_research.fe0fc3ac.svg";